import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 社内製造データの検索
 */
export function SearchInternalFactureData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchInternalFactureData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 社内製造データの更新
 */
export function UpdateInternalManufactureData(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdateInternalManufactureData,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}



